export default __webpack_public_path__ + "static/media/2-FactionGenerator-content.440e3fbc.md";